import $ from "jquery"
class dateFilterTable {
  constructor(vue) {
    this.context = vue
    this.appId = ""
    this.request_prefix = this.context.request_prefix
    this.restUrl = null // 分类数据
    this.containerId = 0
  }
  init() {
    this.getRelativeInfo()
    let popChild = this.context.$el
    $(popChild).addClass("relativeTable")
  }
  getRelativeInfo() {
    //通栏中查找rectid
    let relativeId = this.context.options.relativeComponentId?.rect_id
    if (relativeId === undefined || relativeId === null) {
      return false
    }
    //  监听
    this.initCalendarWatcher(relativeId)
  }
  initCalendarWatcher(relativeId) {
    const self = this
    this.context.$watch(
      function () {
        return self.context.dateType.indexOf("range") > -1 ? self.context.options.startDate : self.context.options.value
      },
      async function (newVal, oldVal) {
        console.log('newVal :>>',newVal, oldVal);
        if (!newVal) {
          self.context.$eventBus.$emit(`update-table-data-eventBus-${self.containerId}-${relativeId}`, {
            dateVal: undefined
          })
          return
        }
        //sf  ef参数的值
        let dateArr = [6,6]
        const newDate = newVal.split("#")
        const startDate = newDate[0]
        dateArr.push(startDate)
        const endDate = newDate[1] ? newDate[1] : startDate
        dateArr.push(endDate)
        self.postUpdate(relativeId, dateArr)
      },
      {
        immediate: true
      }
    )
  }
  postUpdate(relativeId, dateArr) {
    const self = this
    const rect_id = self.context.myid?.rect_id || self.context.ids?.rect_id
    dateArr.push(rect_id)
    // 通知表格更新数据
    self.context.$eventBus.$emit(`update-table-data-eventBus-${self.containerId}-${relativeId}`, {
      dateVal: dateArr
    })
  }
}
export default {
  methods: {
    dateFilterTablePlugin() {
      const datePicker = new dateFilterTable(this)
      datePicker.init()
    }
  }
}
